import * as Sentry from '@sentry/react'

/**
 * Initialise Sentry once at boot. DSN is injected at build time via
 * VITE_SENTRY_DSN. When unset (local dev / first-time deploy) the SDK
 * becomes a passthrough so nothing breaks.
 */
export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined
  if (!dsn) return

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    release: import.meta.env.VITE_SENTRY_RELEASE as string | undefined,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    // Production: lower trace sample so cost stays predictable.
    tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
    // Session replay: 10% of sessions sampled; 100% on error.
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  })
}

/** Tag the current admin user on every subsequent Sentry event. */
export function setSentryUser(id: string, role: string) {
  Sentry.setUser({ id, segment: 'admin' })
  Sentry.setTag('admin_role', role)
}

export function clearSentryUser() {
  Sentry.setUser(null)
}

export { Sentry }
